import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { useAudioPlayer } from '../hooks/useAudioPlayer';

const AudioPlayerContext = createContext(null);

export const AudioPlayerProvider = ({ children = null }) => {
  const audioPlayer = useAudioPlayer();

  return (
    <AudioPlayerContext.Provider value={audioPlayer}>
      {children}
    </AudioPlayerContext.Provider>
  );
};

AudioPlayerProvider.propTypes = {
  children: PropTypes.node,
};

export const useAudioPlayerContext = () => {
  const context = useContext(AudioPlayerContext);
  if (!context) {
    throw new Error('useAudioPlayerContext must be used within an AudioPlayerProvider');
  }
  return context;
};

export default AudioPlayerProvider;
